import { nanoid } from 'nanoid/async'
import { carouselSingleModal } from './carouselSingleModal'
import { updateNodeConnections } from '../../utils/functions'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: carouselSingleData } = await carouselSingleModal(oldData, node)

  if (carouselSingleData && Object.values(carouselSingleData).length > 1) {
    // Create text unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }
    
    Object.assign(node.data, carouselSingleData)
    node.update()
    updateNodeConnections(node)
  }

  return false
}